import { render, staticRenderFns } from "./WidgetsKeyResultHome.vue?vue&type=template&id=882d15f6&"
import script from "./WidgetsKeyResultHome.vue?vue&type=script&lang=js&"
export * from "./WidgetsKeyResultHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports